import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, NavLink, Switch } from 'react-router-dom'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import Sidebar from '../sidebar'
import Home from '../home'
import About from '../about'
import Structure from '../structures/results'
import Jmol from '../structures/jmol'
import Project from '../project'
import Calculations from '../calculations'
import Projects from '../project/projects'
import { getCurrentUser } from '../../modules/user'
import { getAllStructures } from '../../modules/structures'
import { getAllProjects } from '../../modules/projects'

import './navbar.css'
import './router.css'

class NavbarComp extends Component {
  constructor(props) {
    super(props);

      this.toggleNavbar = this.toggleNavbar.bind(this);
      this.toggle = this.toggle.bind(this);
      this.state = {
        dropdownOpen: false,
        collapsed: true
    };
  }

  componentWillMount() {
    this.props.getCurrentUser();
    //this.props.getAllStructures();
    this.props.getAllProjects();
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const { firstName = '', lastName = '' } = this.props.user;
    return (
      <div>
        <header className="masterHead">
          <Navbar className="navbar-expand-md" fixed="top" color="teal">
            <NavbarBrand href="/">
              <object aria-label="logo" className="logo" type="image/svg+xml" data="/qcats12b.svg" alt="logo" style={{height: '32px', width: '32px', marginRight: '.5rem', verticalAlign: 'middle'}}/>
              <span style={{verticalAlign: 'middle', fontWeight:500,letterSpacing:-1,color:"#FFF"}}>Quantum CATS</span>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse isOpen={!this.state.collapsed} navbar>
              {/*console.log('STATE:', this.props)}
                <nav className="breadcrumb mb-0 border-bottom-0">
                <a className="breadcrumb-item text-light" href="#">Home</a>
                <a className="breadcrumb-item text-light" href="#">Library</a>
                <a className="breadcrumb-item text-light" href="#">Data</a>
                <span className="breadcrumb-item text-light active">Bootstrap</span>
              </nav>*/}
              {/* <Nav navbar className="mr-auto">
                <NavItem>
                  <NavLink className="nav-link" to="/" activeClassName="active" exact>Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className="nav-link" to="/about-us" activeClassName="active">About</NavLink>
                </NavItem>
              </Nav> */}
              <Nav navbar className="ml-auto">
                <NavItem>
                  <Dropdown color="white" className="nav-item" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle color="white" className="btn-link nav-link text-white" caret>
                      {firstName} {lastName}
                    </DropdownToggle>
                    <DropdownMenu right>
                      <NavLink className="dropdown-item text-dark" to="/logout" activeClassName="active">logout</NavLink>
                    </DropdownMenu>
                  </Dropdown>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </header>
        <div className="flex-container">
          <Sidebar/>
          <div className="main">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/projects" component={Projects} />
              <Route exact path="/calculations" component={Calculations} />
              <Route exact path="/projects/:projectId" component={Project} />
              <Route exact path="/projects/:projectId/structures/:structureId" component={Structure} />
              <Route exact path="/projects/:projectId/structures/:structureId/jmol" component={Jmol} />
              <Route exact path="/about-us" component={About} />
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getCurrentUser,
  getAllStructures,
  getAllProjects
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NavbarComp))



// WEBPACK FOOTER //
// ./src/containers/app/navbar.js